import {createAction, handleActions} from 'redux-actions';

const initialState = {
    config: {},
    query: '',
    loadStatusItemList: 'ready',
    loadStatusItem: 'ready',

    listPage: '',
    itemList: null,
    itemListTitle: '',
    itemId: null,
    skillId: null,
    skillLevel: 1,
    detail: {},
    recentlyViewList: [],
    
    isUserSelect: false,
    isRecentShow: false,
    detailIsShow: false,
    sidebarIsShow: false,
    stopListLoad: false,
    stopDetailLoad: false,
    
    grades: {},
    typesOper: {},
    types: {},
    categories: [],
    
    selLvMin: null,
    selLvMax: null,
    selTypesOper: '',
    selType: '',
    selRaceId: null,
    selClassId: null,

    selectGrades: '',
    selectCategories: 0,
};

// types--------------------------------------------------------------------------------
export const SET_CONFIG = 'gamedicapp/SET_CONFIG';
export const SET_QUERY = 'gamedicapp/SET_QUERY';
export const SET_ITEMID = 'gamedicapp/SET_ITEMID';
export const SET_SKILLID = 'gamedicapp/SET_SKILLID';
export const SET_SKILLLEVEL = 'gamedicapp/SET_SKILLLEVEL';
export const SET_LISTPAGE = 'gamedicapp/SET_LISTPAGE';
export const SET_USERSELECT = 'gamedicapp/SET_USERSELECT';

export const SET_TYPESOPER_SEL = 'gamedicapp/SET_TYPESOPER_SEL';
export const SET_TYPE_SEL = 'gamedicapp/SET_TYPE_SEL';
export const SET_LVMIN_SEL = 'gamedicapp/SET_LVMIN_SEL';
export const SET_LVMAX_SEL = 'gamedicapp/SET_LVMAX_SEL';
export const SET_RACEID_SEL = 'gamedicapp/SET_RACEID_SEL';
export const SET_CLASSID_SEL = 'gamedicapp/SET_CLASSID_SEL';

export const SET_TYPESOPER = 'gamedicapp/SET_TYPESOPER';
export const SET_TYPES = 'gamedicapp/SET_TYPES';
export const SET_CATEGORIES = 'gamedicapp/SET_CATEGORIES';
export const SET_RECENTLIST = 'gamedicapp/SET_RECENTLIST';
export const ADD_RECENTLIST = 'gamedicapp/ADD_RECENTLIST';
export const REMOVE_RECENTLIST = 'gamedicapp/REMOVE_RECENTLIST';
export const SET_ISRECENTSHOW = 'gamedicapp/SET_ISRECENTSHOW';
export const SET_ITEMLIST = 'gamedicapp/SET_ITEMLIST';
export const SET_ITEMLIST_TITLE = 'gamedicapp/SET_ITEMLIST_TITLE';
export const LOAD_STATUS_ITEMLIST = 'gamedicapp/LOAD_STATUS_ITEMLIST';
export const SET_DETAIL = 'gamedicapp/SET_DETAIL';
export const LOAD_STATUS_DETAIL = 'gamedicapp/LOAD_STATUS_DETAIL';
export const SET_DETAIL_ISSHOW = 'gamedicapp/SET_DETAIL_ISSHOW';
export const SET_SIDEBAR_ISSHOW = 'gamedicapp/SET_SIDEBAR_ISSHOW';
export const SET_STOPLISTLOAD = 'gamedicapp/SET_STOPLISTLOAD';
export const SET_STOPDETAILLOAD = 'gamedicapp/SET_STOPDETAILLOAD';
export const SET_GRADES_SEL = 'gamedicapp/SET_GRADES_SEL';
export const SET_CATEGORIES_SEL = 'gamedicapp/SET_CATEGORIES_SEL';
export const SET_GRADES = 'gamedicapp/SET_GRADES';

// actions--------------------------------------------------------------------------------
export const actions = {
    setConfig: createAction(SET_CONFIG),
    setQuery: createAction(SET_QUERY),
    setItemid: createAction(SET_ITEMID),
    setSkillId: createAction(SET_SKILLID),
    setSkillLevel: createAction(SET_SKILLLEVEL),
    setListpage: createAction(SET_LISTPAGE),
    setUserselect: createAction(SET_USERSELECT),

    setGradesSel: createAction(SET_GRADES_SEL),
    setCategoriesSel: createAction(SET_CATEGORIES_SEL),

    setTypesoperSel: createAction(SET_TYPESOPER_SEL),
    setTypeSel: createAction(SET_TYPE_SEL),
    setLvminSel: createAction(SET_LVMIN_SEL),
    setLvmaxSel: createAction(SET_LVMAX_SEL),
    setRaceidSel: createAction(SET_RACEID_SEL),
    setClassidSel: createAction(SET_CLASSID_SEL),

    setIsRecentShow: createAction(SET_ISRECENTSHOW),
    setRecentList: createAction(SET_RECENTLIST),
    addRecentList: createAction(ADD_RECENTLIST),
    removeRecentList: createAction(REMOVE_RECENTLIST),

    setDetailIsshow: createAction(SET_DETAIL_ISSHOW),
    setSidebarIsshow: createAction(SET_SIDEBAR_ISSHOW),
    setStopListLoad: createAction(SET_STOPLISTLOAD),
    setStopDetailLoad: createAction(SET_STOPDETAILLOAD),

    setGrades: createAction(SET_GRADES),
    loadGrades: () => (dispatch, getState) => {
        axios.get(`${getState().config.apiDomain}/item/grades`, {params: {serverType:getState().config.tab}})
        .then( (_res) => {
            _res.data.unshift({id: '', name: "등급 전체", grade: ""});
            dispatch( actions.setGrades(_res.data) );
        })
        .catch( (error, d) => console.log(error,'loadGrades----', d) )
        .then( (d) => {} );
    },

    setTypes: createAction(SET_TYPES),
    setTypesoper: createAction(SET_TYPESOPER),
    loadTypes: () => (dispatch, getState) => {
        axios.all([
            axios.get(`${getState().config.apiDomain}/skill/operate-types`, {params: {serverType:getState().config.tab}}),
            axios.get(`${getState().config.apiDomain}/skill/types`, {params: {serverType:getState().config.tab}})
        ])
        .then(axios.spread((_dataA, _dataB) => {
            _dataA.data.unshift({name: "분류 전체", alias: ''});
            _dataB.data.unshift({name: "타입 전체", id: ''});

            let typesTemp = _dataA.data.map(it => {
                it.id = it.alias
                return it;
            });
            dispatch( actions.setTypesoper(typesTemp) );
            dispatch( actions.setTypes(_dataB.data) );
        }))
        .catch( (error, d) => console.log(error,'loadGrades----', d) )
        .then( (d) => {} );
    },

    setCategories: createAction(SET_CATEGORIES),
    loadCategories: () => (dispatch, getState) => {
        axios.get(`${getState().config.apiDomain}/${getState().config.db}/categories`, {params: {serverType:getState().config.tab}})
        .then( (_res) => dispatch( actions.setCategories(_res.data) ) )
        .catch( (error, _res) => console.log( error, 'loadCategories' )  )
        .then( (d) => {} );
    },

    loadPopular: () => (dispatch, getState) => {
        dispatch( actions.loadStatusItemList('isLoading') );

        axios.get(`${getState().config.apiDomain}/${getState().config.db}/popular`, {params: {serverType:getState().config.tab}})
        .then( (_res) => {
            dispatch( actions.setItemListTitle(`인기 ${getState().config.db=='item'?'아이템': '스킬'}`) );
            dispatch( actions.setItemList({ data:_res.data, page:1, pageSize:15, totalCount:_res.data.length }) );
        })
        .catch( (error, d) => console.log(error,'loadPopular----', d) )
        .then( (d) => dispatch( actions.loadStatusItemList('isLoadComp') ) );
    },

    loadStatusItemList: createAction(LOAD_STATUS_ITEMLIST),
    setItemList: createAction(SET_ITEMLIST),
    setItemListTitle: createAction(SET_ITEMLIST_TITLE),
    loadItemList: (_nowPageNum=1) => (dispatch, getState) => {
        dispatch( actions.loadStatusItemList('isLoading') );
        let paramObj = { page: _nowPageNum, size: 15, serverType: getState().config.tab };
        if (getState().query) paramObj.query = getState().query;
        if (getState().config.db=='item') {
            if (getState().selectCategories) paramObj.categoryId = getState().selectCategories;
            if (getState().selectGrades) paramObj.gradeId = getState().selectGrades;
        } else if (getState().config.db=='skill'){
            if (getState().selTypesOper) paramObj.operateType = getState().selTypesOper;
            if (getState().selType) paramObj.typeId = getState().selType;
            if (getState().selRaceId) paramObj.raceId = getState().selRaceId;
            if (getState().selClassId) paramObj.classId = getState().selClassId;
            if (getState().selLvMin) paramObj.minLevel = getState().selLvMin;
            if (getState().selLvMax) paramObj.maxLevel = getState().selLvMax;
        }
        
        axios.get(`${getState().config.apiDomain}/${getState().config.db}`, {params: paramObj})
        .then( (_res) => {
            _res.data.time = +new Date();
            dispatch( actions.setItemListTitle('검색 결과') );
            dispatch( actions.setItemList(_res.data) );
        })
        .catch( (error, _res) => {
            dispatch( actions.setItemList({data:[], time: +new Date(), errMessage: true}) );
        })
        .then( (d) => dispatch( actions.loadStatusItemList('isLoadComp') ) );
    },

    loadStatusDetail: createAction(LOAD_STATUS_DETAIL),
    setDetail: createAction(SET_DETAIL),
    loadDetail: (_sel='item', _skillLevel=1) => (dispatch, getState) => {
        dispatch( actions.loadStatusDetail('isLoading') );
        if (_sel==='item' && getState().itemId) {
            axios.all([
                axios.get(`${getState().config.apiDomain}/item/${getState().itemId}`, {params: {serverType:getState().config.tab, increaseViewCount: getState().isUserSelect}}),
                axios.get(`${getState().config.apiDomain}/item/${getState().itemId}/events`, {params: {serverType:getState().config.tab}})
            ])
            .then(axios.spread((_dataA, _dataB) => {
                _dataA.data.eventInfo = _dataB.data;
                dispatch( actions.setDetail(_dataA.data) );
            }))
            .catch( (error, d) => {
                console.log(error,'load Item----??', d);
                dispatch( actions.setDetail({time: +new Date(), errMessage: true}) );
            })
            .then( (d) => dispatch( actions.loadStatusDetail('isLoadComp') ) );
        }
        if (_sel==='skill' && getState().skillId) {
            axios.all([
                axios.get(`${getState().config.apiDomain}/skill/${getState().skillId}`, {params: {level:_skillLevel, serverType:getState().config.tab, increaseViewCount: getState().isUserSelect}}),
                axios.get(`${getState().config.apiDomain}/skill/${getState().skillId}/level-range`, {params: {serverType:getState().config.tab}})
            ])
            .then(axios.spread((_dataA, _dataB) => {
                _dataA.data.levelRange = _dataB.data;
                dispatch( actions.setDetail(_dataA.data) );
            }))
            .catch( (error, d) => {
                console.log(error,'load skill----??', d)
                dispatch( actions.setDetail({time: +new Date(), errMessage: true}) );
            })
            .then( (d) => dispatch( actions.loadStatusDetail('isLoadComp') ) );
        }
    }
};

// handlers--------------------------------------------------------------------------------
export default handleActions({
    [SET_CONFIG] : (state, action) => $.extend(true, {}, state, {config: action.payload}),

    [SET_QUERY] : (state, action) => $.extend(true, {}, state, {query: action.payload}),
    [SET_ITEMID] : (state, action) => $.extend(true, {}, state, {itemId: action.payload}),
    [SET_SKILLID] : (state, action) => $.extend(true, {}, state, {skillId: action.payload}),
    [SET_SKILLLEVEL] : (state, action) => $.extend(true, {}, state, {skillLevel: action.payload}),
    [SET_LISTPAGE] : (state, action) => $.extend(true, {}, state, {listPage: action.payload}),
    [SET_USERSELECT] : (state, action) => $.extend(true, {}, state, {isUserSelect: action.payload}),

    [SET_GRADES_SEL] : (state, action) => $.extend(true, {}, state, {selectGrades: action.payload}),
    [SET_CATEGORIES_SEL] : (state, action) => $.extend(true, {}, state, {selectCategories: action.payload}),
    [SET_TYPESOPER_SEL] : (state, action) => $.extend(true, {}, state, {selTypesOper: action.payload}),
    [SET_TYPE_SEL] : (state, action) => $.extend(true, {}, state, {selType: action.payload}),
    [SET_LVMIN_SEL] : (state, action) => $.extend(true, {}, state, {selLvMin: action.payload}),
    [SET_LVMAX_SEL] : (state, action) => $.extend(true, {}, state, {selLvMax: action.payload}),
    [SET_RACEID_SEL] : (state, action) => $.extend(true, {}, state, {selRaceId: action.payload}),
    [SET_CLASSID_SEL] : (state, action) => $.extend(true, {}, state, {selClassId: action.payload}),
    [SET_STOPLISTLOAD] : (state, action) => $.extend(true, {}, state, {stopListLoad: action.payload}),
    [SET_STOPDETAILLOAD] : (state, action) => $.extend(true, {}, state, {stopDetailLoad: action.payload}),

    [SET_DETAIL_ISSHOW] : (state, action) => $.extend(true, {}, state, {detailIsShow: action.payload}),
    [SET_SIDEBAR_ISSHOW] : (state, action) => $.extend(true, {}, state, {sidebarIsShow: action.payload}),

    [SET_ISRECENTSHOW] : (state, action) => $.extend(true, {}, state, {isRecentShow: action.payload}),
    [SET_RECENTLIST] : (state, action) => $.extend(true, {}, state, {recentlyViewList: action.payload}),
    [ADD_RECENTLIST] : (state, action) => {
        let dat = $.extend(true, {}, state);
        for (let i=0; i < dat.recentlyViewList.length; i++) {
            if (dat.recentlyViewList[i].id === action.payload.id && dat.recentlyViewList[i].db === action.payload.db) {
                dat.recentlyViewList.splice(i, 1);
            }
        }
        dat.recentlyViewList.unshift( action.payload );
        dat.recentlyViewList = dat.recentlyViewList.slice(0,100);
        localStorage.setItem('gameDicRecentlyViewList'+state.config.tab, JSON.stringify(dat.recentlyViewList));
        return dat;
    },
    [REMOVE_RECENTLIST] : (state, action) => {
        let dat = $.extend(true, {}, state);
        for (let i=0; i < dat.recentlyViewList.length; i++) {
            if (dat.recentlyViewList[i].id === action.payload.id && dat.recentlyViewList[i].db === action.payload.db) {
                dat.recentlyViewList.splice(i, 1);
            }
        }
        // console.log( '_____', action.payload );
        // dat.recentlyViewList.unshift( action.payload );
        localStorage.setItem('gameDicRecentlyViewList'+state.config.tab, JSON.stringify(dat.recentlyViewList));
        return dat;
    },
    
    [SET_TYPESOPER] : (state, action) => $.extend(true, {}, state, {typesOper: action.payload}),
    [SET_TYPES] : (state, action) => $.extend(true, {}, state, {types: action.payload}),

    [SET_GRADES] : (state, action) => $.extend(true, {}, state, {grades: action.payload}),
    [SET_CATEGORIES] : (state, action) => $.extend(true, {}, state, {categories: action.payload}),
    
    [LOAD_STATUS_ITEMLIST] : (state, action) => $.extend(true, {}, state, {loadStatusItemList: action.payload}),
    [SET_ITEMLIST_TITLE] : (state, action) => $.extend(true, {}, state, {itemListTitle: action.payload}),
    [SET_ITEMLIST] : (state, action) => {
        let dat = $.extend(true, {}, state, {itemList: {}});
            dat.itemList = action.payload;
        return dat;
    },
    
    [LOAD_STATUS_DETAIL] : (state, action) => $.extend(true, {}, state, {loadStatusDetail: action.payload}),
    [SET_DETAIL] : (state, action) => {
        let dat = $.extend(true, {}, state, {detail: {}});
            dat.detail = action.payload;
        return dat;
    }

}, initialState);